import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import { useUIStore } from '../../stores/uiStore';
import QuestionsTab from '../mercadolibre/QuestionsTab';

export default function QuestionsPage() {
  const { t } = useTranslation();
  const { sellerId } = useUIStore();

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <MessageCircle size={24} className="text-[var(--color-primary)]" />
        <h1 className="text-xl font-semibold text-[var(--color-text)]">{t('nav.questions')}</h1>
      </div>
      <QuestionsTab sellerId={sellerId} />
    </div>
  );
}
